import React from "react";
import { clamp } from "../lib/node";

/**
 * `value` is a 0..100 percentage. The height has to be an inline style: a
 * runtime-built class like `h-${value}/100` is invisible to Tailwind's JIT,
 * which is why this gauge never filled.
 */
const PanSlider = ({ value }: { value: number }) => (
  <div className="relative w-32 h-64 bg-gray-200 rounded-xl dark:bg-gray-700 flex items-end overflow-hidden">
    <div
      className="w-full bg-blue-600 dark:bg-blue-500 transition-[height] duration-300"
      style={{ height: `${clamp(value || 0, 0, 100)}%` }}
    >
      &nbsp;
    </div>
  </div>
);

export default PanSlider;
